import axios from "axios";
import { server } from "../api";

const IndoorPositioningLive = {
  GetPersonnel: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/live/personnel`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取人員即時資料失敗",
        }
      );
    }
  },

  GetAlerts: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/live/alerts`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取警報資料失敗",
        }
      );
    }
  },

  AcknowledgeAlert: async (machineID, alertId, acknowledgedBy = null) => {
    try {
      const body = acknowledgedBy != null ? { acknowledgedBy } : {};
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/live/alerts/${alertId}/acknowledge`,
        body
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "確認警報失敗",
        }
      );
    }
  },

  DismissAlert: async (machineID, alertId, dismissedBy = null) => {
    try {
      const body = dismissedBy != null ? { dismissedBy } : {};
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/live/alerts/${alertId}/dismiss`,
        body
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "關閉警報失敗",
        }
      );
    }
  },

  GetStats: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/live/stats`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取統計資料失敗",
        }
      );
    }
  },
};

export default IndoorPositioningLive;
